import api from '../api/axios';

const getList = (skip = 0, take = 25, query = '', status = '', priority = '', techId = '') => {
  let url = `/warranty-ticket?skip=${skip}&take=${take}&sort=createdAt%2Cdesc`;
  if (query) url += `&query=${encodeURIComponent(query)}`;
  if (status) url += `&status=${encodeURIComponent(status)}`;
  if (priority) url += `&priority=${encodeURIComponent(priority)}`;
  if (techId) url += `&techId=${techId}`;
  return api.get(url);
};

const getById = (id) => {
  return api.get(`/warranty-ticket/${id}`);
};

const create = (data) => {
  return api.post('/warranty-ticket', data);
};

const update = (id, data) => {
  return api.patch(`/warranty-ticket/${id}`, data);
};

const changeStatus = (id, status) => {
  return api.patch(`/warranty-ticket/${id}/status`, { status });
};

const resolve = (id, completionNotes) => {
  return api.patch(`/warranty-ticket/${id}/resolve`, { completionNotes });
};

const remove = (id) => {
  return api.delete(`/warranty-ticket/${id}`);
};

const getByProposal = (proposalId) => {
  return api.get(`/warranty-ticket/by-proposal/${proposalId}`);
};

const getByProperty = (propertyId) => {
  return api.get(`/warranty-ticket/by-property/${propertyId}`);
};

const searchRequest = (skip = 0, take = 25, query = '', withDeleted = false, options = {}) => {
  return api.get(`/warranty-ticket?skip=${skip}&take=${take}&sort=createdAt%2Cdesc&query=${encodeURIComponent(query)}`, { ...options });
};

const sendPartsOrder = (ticketId, orders, replyTo) => {
  return api.post(`/warranty-ticket/${ticketId}/send-parts-order`, { orders, replyTo });
};

const createProposal = (ticketId) => {
  return api.post(`/warranty-ticket/${ticketId}/create-proposal`);
};

const getActiveCount = () => {
  return api.get('/warranty-ticket/active-count');
};

const listPhotos = (ticketId) => {
  return api.get(`/warranty-ticket/${ticketId}/photos`);
};

const listAvailablePhotos = (ticketId) => {
  return api.get(`/warranty-ticket/${ticketId}/available-photos`);
};

const listPropertyAvailablePhotos = (propertyId) => {
  return api.get(`/warranty-ticket/property/${propertyId}/available-photos`);
};

const attachPhotos = (ticketId, mediaIds) => {
  return api.post(`/warranty-ticket/${ticketId}/photos`, { mediaIds });
};

const detachPhoto = (ticketId, mediaId) => {
  return api.delete(`/warranty-ticket/${ticketId}/photos/${mediaId}`);
};

const scaPrefill = (ticketId) => {
  return api.get(`/warranty-ticket/${ticketId}/sca-prefill`);
};

const scaPdf = (ticketId, form) => {
  return api.post(`/warranty-ticket/${ticketId}/sca-pdf`, form, { responseType: 'blob' });
};

const scaSend = (ticketId, payload) => {
  return api.post(`/warranty-ticket/${ticketId}/sca-send`, payload);
};

const scaClaimsList = () => {
  return api.get('/warranty-ticket/sca-claims/list');
};

const scaClaimUpdate = (claimId, moneyReceived) => {
  return api.patch(`/warranty-ticket/sca-claims/${claimId}`, { moneyReceived });
};

const scaClaimPdf = (claimId) => {
  return api.get(`/warranty-ticket/sca-claims/${claimId}/pdf`, { responseType: 'blob' });
};

const warrantyTicketServices = {
  getList,
  getById,
  create,
  update,
  changeStatus,
  resolve,
  remove,
  getByProposal,
  getByProperty,
  searchRequest,
  sendPartsOrder,
  createProposal,
  getActiveCount,
  listPhotos,
  listAvailablePhotos,
  listPropertyAvailablePhotos,
  attachPhotos,
  detachPhoto,
  scaPrefill,
  scaPdf,
  scaSend,
  scaClaimsList,
  scaClaimUpdate,
  scaClaimPdf,
};

export default warrantyTicketServices;
